import { useAuthContext } from './adminAuthHook'
import { getProfile } from '../redux/reducers/adminProfileSlice'
import { useDispatch } from 'react-redux';

export default function ProfileHook() {
  const dispatch = useDispatch()
  const apiUrl = process.env.REACT_APP_API_URL;
  const { agency } = useAuthContext()
  const getAdminProfile = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/admin/get/profile`, {
        headers: {
          'Authorization': `Bearer ${agency.token}`

        }
      })

      const json = await response.json()
      if (response.ok) {

        dispatch(getProfile(json.data))
      }

    } catch (error) {
      console.log('error', error)
    }
  }
  return { getAdminProfile }
}
